import { Box } from "@mui/material";

export const LayoutWrapper = ({ children }) => {
  return (
    <Box sx={{ padding: (theme) => theme.spacing(5, 7.5) }}>{children}</Box>
  );
};
